<!-- Main Modal -->
<div class="modal fade" [class.show]="isOpen" [style.display]="isOpen ? 'block' : 'none'" tabindex="-1" role="dialog">
  <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header bg-light">
        <h5 class="modal-title">
          <i class="bi bi-cash-stack text-success me-2"></i>
          Agent Pricing Management
        </h5>
        <button type="button" class="btn-close" (click)="close()"></button>
      </div>

      <!-- Body -->
      <div class="modal-body">
        <!-- Search Bar -->
        <div class="row mb-3">
          <div class="col-md-8">
            <div class="input-group">
              <span class="input-group-text">
                <i class="bi bi-search"></i>
              </span>
              <input
                type="text"
                class="form-control"
                placeholder="Search by agent or port..."
                [(ngModel)]="searchTerm"
                (input)="onSearch()"
              />
            </div>
          </div>
          <div class="col-md-4 text-end">
            <button class="btn btn-primary" (click)="openAddRouteModal()">
              <i class="bi bi-plus-circle me-1"></i> Add Agent Route
            </button>
          </div>
        </div>

        <!-- Agent Routes Summary -->
        <div class="row mb-4">
          <div class="col-md-4">
            <div class="card bg-primary bg-opacity-10 border-primary">
              <div class="card-body text-center">
                <h3 class="text-primary mb-0">{{ stats.totalRoutes }}</h3>
                <small class="text-muted">Total Routes</small>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card bg-success bg-opacity-10 border-success">
              <div class="card-body text-center">
                <h3 class="text-success mb-0">{{ stats.activeAgents }}</h3>
                <small class="text-muted">Active Agents</small>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="card bg-info bg-opacity-10 border-info">
              <div class="card-body text-center">
                <h3 class="text-info mb-0">{{ stats.uniquePorts }}</h3>
                <small class="text-muted">Unique Ports</small>
              </div>
            </div>
          </div>
        </div>

        <!-- Agent Routes Table -->
        <div class="table-responsive">
          <table class="table table-hover">
            <thead class="table-light">
              <tr>
                <th>Agent</th>
                <th>Route (Origin → Destination)</th>
                <th>Created Date</th>
                <th class="text-end">Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngIf="filteredRoutes.length === 0">
                <td colspan="4" class="text-center text-muted py-4">
                  <i class="bi bi-inbox fs-1 d-block mb-2"></i>
                  No agent routes found
                </td>
              </tr>
              <tr *ngFor="let route of filteredRoutes">
                <td>
                  <strong>{{ route.agentName }}</strong>
                </td>
                <td>
                  <span class="badge bg-secondary me-1">{{ route.originPortCode }}</span>
                  {{ route.originPortName }}
                  <i class="bi bi-arrow-right mx-2"></i>
                  <span class="badge bg-secondary me-1">{{ route.destinationPortCode }}</span>
                  {{ route.destinationPortName }}
                </td>
                <td>{{ formatDate(route.createdAt) }}</td>
                <td class="text-end">
                  <button
                    class="btn btn-sm btn-outline-primary me-1"
                    (click)="openManagePricing(route)"
                    title="Manage Pricing"
                  >
                    <i class="bi bi-currency-dollar"></i> Manage Pricing
                  </button>
                  <button
                    class="btn btn-sm btn-outline-danger"
                    (click)="deleteRoute(route)"
                    title="Delete Route"
                  >
                    <i class="bi bi-trash"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="close()">
          <i class="bi bi-x-circle me-1"></i> Close
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Add Agent Route Modal -->
<div class="modal fade" [class.show]="showAddRouteModal" [style.display]="showAddRouteModal ? 'block' : 'none'" tabindex="-1" role="dialog" style="z-index: 1055;">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Add Agent Route</h5>
        <button type="button" class="btn-close" (click)="closeAddRouteModal()"></button>
      </div>
      <div class="modal-body">
        <form>
          <div class="mb-3">
            <label class="form-label">Agent <span class="text-danger">*</span></label>
            <select class="form-select" [(ngModel)]="newRoute.agentId" name="agentId" required>
              <option value="0">Select agent...</option>
              <option *ngFor="let agent of agents" [value]="agent.id">
                {{ agent.name }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label class="form-label">Origin Port <span class="text-danger">*</span></label>
            <select class="form-select" [(ngModel)]="newRoute.originPortId" name="originPortId" required>
              <option value="0">Select origin...</option>
              <option *ngFor="let port of ports" [value]="port.id">
                {{ port.code }} - {{ port.name }}
              </option>
            </select>
          </div>
          <div class="mb-3">
            <label class="form-label">Destination Port <span class="text-danger">*</span></label>
            <select class="form-select" [(ngModel)]="newRoute.destinationPortId" name="destinationPortId" required>
              <option value="0">Select destination...</option>
              <option *ngFor="let port of ports" [value]="port.id">
                {{ port.code }} - {{ port.name }}
              </option>
            </select>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeAddRouteModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="createAgentRoute()">
          <i class="bi bi-plus-circle me-1"></i> Create Agent Route
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Manage Pricing Modal -->
<div class="modal fade" [class.show]="showManagePricingModal" [style.display]="showManagePricingModal ? 'block' : 'none'" tabindex="-1" role="dialog" style="z-index: 1055;">
  <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <div class="d-flex flex-column">
          <div class="mb-2">
            <button class="btn btn-sm btn-outline-secondary" (click)="closeManagePricingModal()">
              <i class="bi bi-arrow-left me-1"></i> Back to Routes
            </button>
          </div>
          <h5 class="mb-0" *ngIf="selectedRoute">
            Agent Pricing Management
          </h5>
          <p class="text-muted small mb-0" *ngIf="selectedRoute">
            {{ selectedRoute.agentName }} • {{ selectedRoute.originPortCode }} - {{ selectedRoute.originPortName }} → {{ selectedRoute.destinationPortCode }} - {{ selectedRoute.destinationPortName }}
          </p>
        </div>
        <button type="button" class="btn-close" (click)="closeManagePricingModal()"></button>
      </div>
      <div class="modal-body">
        <!-- Apply Validity Dates Section -->
        <div class="card mb-4">
          <div class="card-body">
            <h6 class="card-title mb-3">
              <i class="bi bi-calendar3 me-2"></i>Apply Validity Dates to All Charges
            </h6>
            <div class="row align-items-end">
              <div class="col-md-4">
                <label class="form-label small">Valid From</label>
                <input type="date" class="form-control" [(ngModel)]="bulkValidFrom" placeholder="Pick start date">
              </div>
              <div class="col-md-4">
                <label class="form-label small">Valid Until</label>
                <input type="date" class="form-control" [(ngModel)]="bulkValidUntil" placeholder="Pick end date">
              </div>
              <div class="col-md-4">
                <button class="btn btn-primary w-100" (click)="applyBulkValidity()">
                  <i class="bi bi-check-circle me-1"></i>Apply to All Charges
                </button>
              </div>
            </div>
            <small class="text-muted mt-2 d-block">
              This will apply the selected dates to all 14 operational charges below.
            </small>
          </div>
        </div>

        <!-- Operational Charges Pricing Table -->
        <div class="card">
          <div class="card-body">
            <h6 class="card-title mb-3">
              <i class="bi bi-currency-dollar me-2"></i>Operational Charges Pricing
            </h6>
            <div class="table-responsive">
              <table class="table table-bordered table-sm">
                <thead class="table-light">
                  <tr>
                    <th style="width: 200px;">Operational Charge</th>
                    <th style="width: 110px;">Currency</th>
                    <th style="width: 150px;">Charge Basis</th>
                    <th style="width: 100px;">FCL 20ft</th>
                    <th style="width: 100px;">FCL 40ft</th>
                    <th style="width: 100px;">LCL</th>
                    <th style="width: 140px;">Valid From</th>
                    <th style="width: 140px;">Valid Until</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let pricing of pricingData; let i = index">
                    <td>
                      <small class="d-block fw-bold">{{ pricing.operationalChargeName }}</small>
                    </td>
                    <td>
                      <select class="form-select form-select-sm" [(ngModel)]="pricing.currency">
                        <option value="PHP">PHP</option>
                        <option value="USD">USD</option>
                      </select>
                    </td>
                    <td>
                      <select class="form-select form-select-sm" [(ngModel)]="pricing.chargeBasis">
                        <option value="At Cost">At Cost</option>
                        <option value="Fixed Amount">Fixed Amount</option>
                        <option value="Per BL (Bill of Lading)">Per BL (Bill of Lading)</option>
                      </select>
                    </td>
                    <td>
                      <input type="number" class="form-control form-control-sm" [(ngModel)]="pricing.fcl20ft" min="0" step="0.01">
                    </td>
                    <td>
                      <input type="number" class="form-control form-control-sm" [(ngModel)]="pricing.fcl40ft" min="0" step="0.01">
                    </td>
                    <td>
                      <input type="number" class="form-control form-control-sm" [(ngModel)]="pricing.lcl" min="0" step="0.01">
                    </td>
                    <td>
                      <input type="date" class="form-control form-control-sm" [(ngModel)]="pricing.validFrom">
                    </td>
                    <td>
                      <input type="date" class="form-control form-control-sm" [(ngModel)]="pricing.validUntil">
                    </td>
                  </tr>
                  <tr *ngIf="pricingData.length === 0">
                    <td colspan="8" class="text-center text-muted py-4">
                      <i class="bi bi-inbox fs-3 d-block mb-2"></i>
                      No pricing data available
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeManagePricingModal()">Cancel</button>
        <button type="button" class="btn btn-primary" (click)="savePricing()">
          <i class="bi bi-save me-1"></i>Save Pricing
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Backdrop -->
<div class="modal-backdrop fade" [class.show]="isOpen || showAddRouteModal || showManagePricingModal" *ngIf="isOpen || showAddRouteModal || showManagePricingModal" [style.z-index]="showAddRouteModal || showManagePricingModal ? '1054' : '1040'"></div>
